import { Box, Heading, Flex, Text, Stack, Button, SimpleGrid } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export default function CTASection({ bgColor = 'brand.500' }) {
    const { t } = useTranslation("cta");

    const leftItems = t('left.items', { returnObjects: true });
    const itemsArray = Array.isArray(leftItems) ? leftItems : [];

    return (
        <Flex direction={{ base: 'column', xl: 'row' }} w="100%">
            {/* LEFT CONTAINER */}
            <Box
                flex={1}
                position="relative"
                py={{ base: '48px', md: '64px', xl: '88px' }}
                px={{ base: '16px', md: '40px', xl: '72px' }}
                display="flex"
                justifyContent={{ base: 'flex-start', xl: 'flex-end' }}
                overflow="hidden"
                bg={bgColor}
            >
                <Box position="absolute" left="-140px" bottom="-180px" w="460px" h="460px" borderRadius="full" border="1px solid rgba(255,255,255,0.14)" aria-hidden="true" />
                <Box position="absolute" right="-120px" top="-140px" w="380px" h="380px" borderRadius="full" bg="rgba(255,255,255,0.06)" aria-hidden="true" />
                <Stack
                    spacing={{ base: '18px', md: '24px' }}
                    position="relative"
                    zIndex={3}
                    maxW={{ base: '100%', lg: '960px' }}
                    w="100%"
                >
                    <Box>
                        <Heading as="h2" color="white" fontSize={{ base: '28px', md: '32px', lg: '36px' }} fontWeight={700} lineHeight="1.12" letterSpacing="-0.8px">
                            {t('left.title')}
                        </Heading>
                    </Box>

                    <Text color="#F5E4E9" fontSize={{ base: '15px', md: '17px' }} lineHeight="1.65" maxW="580px">
                        {t('left.description')}
                    </Text>

                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: '10px', md: '16px' }} maxW="580px">
                        {itemsArray.map((item, idx) => (
                            <Box
                                key={idx}
                                bg="rgba(255,255,255,0.10)"
                                border="1px solid rgba(255,255,255,0.18)"
                                p={{ base: '18px', md: '22px' }}
                                borderRadius={{ base: '16px', md: '18px' }}
                            >
                                <Text color="white" fontWeight={700} mb={2} display="flex" alignItems="center" gap="10px" fontSize={{ base: '17px', md: '19px' }}>
                                    <Box as="span" fontSize={{ base: '18px', lg: '20px' }}>{item.icon}</Box> {item.title}
                                </Text>
                                <Text color="#F5E4E9" fontSize={{ base: '14px', md: '15px' }} lineHeight="1.55">
                                    {item.description}
                                </Text>
                            </Box>
                        ))}
                    </SimpleGrid>

                    <Box>
                        <Button
                            variant="cta"
                            as="a"
                            href="/"
                            h={{ base: '52px', md: '54px' }}
                            px={'30px'}
                            py={0}
                            w={{ base: '100%', md: 'fit-content' }}
                            fontSize={{ base: '15px', md: '16px' }}
                        >
                            {t('left.button')}
                        </Button>
                    </Box>
                </Stack>
            </Box>

            {/* RIGHT CONTAINER */}
            <Box
                flex={1}
                position="relative"
                py={{ base: '48px', md: '64px', xl: '88px' }}
                px={{ base: '16px', md: '40px', xl: '72px' }}
                display="flex"
                justifyContent="flex-start"
                overflow="hidden"
                bg="brand.700"
            >
                <Box position="absolute" right="-160px" bottom="-200px" w="520px" h="520px" borderRadius="full" border="1px solid rgba(255,255,255,0.08)" aria-hidden="true" />
                <Box position="absolute" right="-60px" bottom="-100px" w="320px" h="320px" borderRadius="full" bg="rgba(244,184,197,0.07)" aria-hidden="true" />
                <Stack
                    spacing={{ base: '18px', md: '24px' }}
                    position="relative"
                    zIndex={3}
                    maxW={{ base: '100%', lg: '960px' }}
                    w="100%"
                >
                    <Box>
                        <Heading as="h2" color="white" fontSize={{ base: '28px', md: '32px', lg: '36px' }} fontWeight={700} lineHeight="1.12" letterSpacing="-0.8px">
                            {t('right.title')}
                        </Heading>
                    </Box>

                    <Text color="#EBD6DC" fontSize={{ base: '15px', md: '17px' }} lineHeight="1.75" maxW="580px">
                        {t('right.description')}
                    </Text>

                    <Box>
                        <Button
                            variant="cta"
                            as="a"
                            href="https://admin.evenado.com/register"
                            color="brand.600"
                            target="_blank"
                            rel="noopener noreferrer"
                            h={{ base: '52px', md: '54px' }}
                            px={'30px'}
                            py={0}
                            w={{ base: '100%', md: 'fit-content' }}
                            fontSize={{ base: '15px', md: '16px' }}
                        >
                            {t('right.button')}
                        </Button>
                    </Box>
                </Stack>
            </Box>
        </Flex>
    );
}